import React, { Component } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Pagination as MuiPagination,
  Grid,
  CircularProgress,
  Button,
  Box,
  Typography,
  IconButton,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Img } from "react-image";
import LoadingScreen from "../parts/loadingScreen";
import Moment from "moment";
import ImagePreviewModal from "../parts/ImagePreviewModal";
import { API_URL, UPLOADS_BUCKET } from "../../config";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

Moment.locale("en");

class AdminDashboard extends Component {
  _isMounted = false;

  state = {
    loading: true,
    activePage: 1,
    pages: 0,
    count: 0,
    photosets: [],
    tiers: [],
    selectedPages: [],
    photolist: [],
    showDetailsModal: false,
    showImagePreviewModal: false,
    selectedPhotoset: null,
    modalLoading: true,
    modalPhotos: [],
    photosetDetails: null,
    photoCount: 0,
    imagePreviewInitialIndex: null,
    versionTime: 1591213166,
  };

  componentDidMount() {
    this._isMounted = true;
    this.getAdminList();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  openImagePreview = (photo, index) => {
    this.setState({
      imagePreviewInitialIndex: index,
      showImagePreviewModal: true,
    });
  };

  closeImagePreview = () => {
    this.setState({
      imagePreviewInitialIndex: null,
      showImagePreviewModal: false,
    });
  };

  pagination = (i = this.state.activePage) => {
    let divisions = Math.ceil(this.state.count / 10);
    if (divisions < 1) divisions = 1;

    if (i < 1) i = 1;
    if (i > divisions) i = divisions;
    
    const floor = (i - 1) * 10;
    const ceil = i * 10;

    const photosets = this.state.photosets;
    const selectedPages = photosets.slice(floor, ceil);

    let sp = [];

    selectedPages.forEach((item) => {
      if (item.photosetName) {
        let sp_list = {
          photosetName: item.photosetName,
          createdAt: item.createdAt,
          id: item.id,
          photosetStatus: item.photosetStatus,
          userId: item.userId,
          photos: this.state.photolist[item.id],
        };

        sp.push(sp_list);
      } else {
        toast.info(
          JSON.stringify(item),
          "Issues detected",
          { autoClose: 20000 }
        );
        console.log("Issue detected", item);
      }
    });

    if (this._isMounted)
      this.setState({
        activePage: i,
        pages: divisions,
        selectedPages: sp,
        loading: false,
      });
  };

  getAdminList = async () => {
    //admin/v1/photosets/list
    try {
      const token = this.props.token;

      const body = JSON.stringify({
        // type: "photosets",
      });

      const response = await fetch(
        API_URL + "/admin/v1/photosets/list",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
          method: "POST",
        }
      );

      const responseData = await response;
      if (responseData.status === 200) {
        const responseJson = await responseData.json();

        console.log(responseJson);
        let photos = [];
        const photolist = responseJson.photolist;

        photolist.forEach((item) => {
          const photosetId = item.photosetId;
          photos[photosetId] = item.photos;
        });

        this.setState({
          count: responseJson.photosetlist.length,
          photosets: responseJson.photosetlist,
          photolist: photos,
          tiers: responseJson.tierList,
        });

        this.pagination(1);
      } else {
        toast.warn("Something went wrong: Error " + responseData.status);
        this.setState({ loading: false });
      }
    } catch (err) {
      toast.error("Error getting photoset list from endpoint: " + err);
    }
  };

  showDetailsModal = (id) => {
    if (this._isMounted)
      this.setState({
        showDetailsModal: true,
        selectedPhotoset: id,
        modalPhotos: [],
        photosetDetails: null,
        modalLoading: true,
      });

    this.getPhotosetDetails(id);
  };

  getPhotosetDetails = async (setId) => {
    try {
      const token = this.props.token;

      const body = JSON.stringify({
        setId: setId,
      });

      const response = await fetch(
        API_URL + "/admin/v1/photosets/details",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
          method: "POST",
        }
      );

      const responseData = await response;
      if (responseData.status === 200) {
        const responseJson = await responseData.json();

        console.log(responseJson);
        if (this._isMounted) {
            this.setState({ photosetDetails: responseJson[0] });
            this.getPhotos(responseJson[0].userId, setId);
        }
      } else {
        toast.warn(
          "Error " + responseData.status,
          "Something went wrong",
          { autoClose: 10000 }
        );
      }
      this.setState({ modalLoading: false });
    } catch (err) {
      console.log("Error getting photoset list from endpoint", err);
      this.setState({ modalLoading: false });
    }
  };

  getPhotos = async (userId, photosetId) => {
    try {
      const token = this.props.token;

      const body = JSON.stringify({
        setId: photosetId,
      });

      const response = await fetch(
        API_URL + "/admin/v1/photosets/list/photos",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
          method: "POST",
        }
      );

      const responseData = await response;
      if (responseData.status === 200) {
        const responseJson = await responseData.json();
        console.log(responseJson);

        const s3 = new S3Client({
          region: "us-east-1",
          credentials: this.props.AWS?.config?.credentials,
        });
        //let images = [];
        if(!this._isMounted) return;
        this.setState({ photoCount: responseJson.length });

        const photoPromises = responseJson.map(async (item) => {
          let filename = item.fileName.replace(/\.[^/.]+$/, "") + ".jpg";
          let key = "photosets/" + userId + "/" + photosetId + "/thumbs/" + filename;

          const command = new GetObjectCommand({
            Bucket: UPLOADS_BUCKET,
            Key: key,
          });

          try {
            const url = await getSignedUrl(s3, command, { expiresIn: 3600 });
            return {
              src: url,
              key: item.id,
              width: 0.5,
              height: 0.5,
              status: item.photoStatus,
              f: item.fileName,
              alt: "thumbs",
            };
          } catch (err) {
            toast.warn("Failed to get thumb for " + item.fileName);
            return null;
          }
        });

        const newImages = (await Promise.all(photoPromises)).filter(Boolean);

        if (this._isMounted) {
          this.setState({
            modalPhotos: newImages,
          });
        }
      } else {
        toast.warn(
          "Error " + responseData.status,
          "Something went wrong",
          10000
        );
      }
      this.setState({ modalLoading: false });
    } catch (err) {
      console.log("Error getting photoset list from endpoint", err);
      this.setState({ modalLoading: false });
    }
  };

  render() {
    if (this.state.loading) return <LoadingScreen />;

    if (!this.state.loading && this.state.selectedPages.length === 0)
      return (
        <Box sx={{p: 5, textAlign: 'center'}}>
          <Typography variant="h4">Empty</Typography>
        </Box>
      );

    return (
      <Box sx={{ p: 5, textAlign: "left" }}>
        <Typography variant="h4" gutterBottom>
          Admin Dashboard
        </Typography>

        {this.state.showImagePreviewModal && (
          <ImagePreviewModal
            open={this.state.showImagePreviewModal}
            onClose={this.closeImagePreview}
            photos={this.state.modalPhotos}
            initialIndex={this.state.imagePreviewInitialIndex}
            photosetDetails={this.state.photosetDetails}
            awsCredentials={this.props.AWS?.config?.credentials}
            userId={this.state.photosetDetails?.userId}
            photosetId={this.state.selectedPhotoset}
            versionTime={this.state.versionTime}
          />
        )}

        <Dialog
          maxWidth="lg"
          fullWidth
          open={this.state.showDetailsModal}
          onClose={() => {
            this.setState({ showDetailsModal: false });
          }}
        >
          {this.state.modalLoading || !this.state.photosetDetails ? (
            <Box sx={{ display: "flex", justifyContent: "center", m: 5, p: 5 }}>
              <CircularProgress />
            </Box>
          ) : (
            <React.Fragment>
              <DialogTitle>
                <Grid container justifyContent="space-between" alignItems="center">
                  <Grid item>
                    <Typography variant="h5" component="div">
                      {this.state.photosetDetails.photosetName}
                    </Typography>
                    <Chip
                      label={this.state.photosetDetails.TierName}
                      size="small"
                      sx={{
                        backgroundColor: this.state.photosetDetails.TierColor,
                        color: "white",
                      }}
                    />
                  </Grid>
                </Grid>
                <IconButton
                  aria-label="close"
                  onClick={() => this.setState({ showDetailsModal: false })}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers sx={{ p: 0 }}>
                <Box sx={{ m: 2 }}>
                  <Typography>
                    Uploaded by {this.state.photosetDetails.userId}
                  </Typography>
                </Box>
                <Box sx={{ width: "100%" }}>
                  {this.state.modalPhotos.length === 0 ? (
                    <Typography variant="h6" sx={{p: 2}}>No photos</Typography>
                  ) : (
                    <Grid container spacing={1} sx={{ p: 2 }}>
                      {this.state.modalPhotos.map((image, index) => (
                        <Grid
                          item
                          key={image.key}
                          lg={2}
                          md={3}
                          sm={4}
                          xs={6}
                          sx={{
                            cursor: image.status === "SUCCESS" ? "pointer" : "default",
                            opacity: image.status === "SUCCESS" ? 1 : 0.5,
                          }}
                          onClick={() => this.openImagePreview(image, index)}
                        >
                          <Img
                            src={image.src}
                            loader={<CircularProgress />}
                            unloader={<CloseIcon />}
                            style={{
                              width: "100%",
                              height: "auto",
                              aspectRatio: "1 / 1",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Box>
              </DialogContent>
            </React.Fragment>
          )}
        </Dialog>

        <Paper sx={{ my: 2 }}>
          <Grid container sx={{ p: 2, borderBottom: "1px solid #ddd" }}>
            <Grid item lg={3} md={3} sm={3} xs={12}>
              <Typography variant="subtitle2">Photoset Name</Typography>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={4}>
              <Typography variant="subtitle2">Date Created</Typography>
            </Grid>
            <Grid item lg={3} md={3} sm={3} xs={8}>
              <Typography variant="subtitle2">Uploaded By</Typography>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={10}>
              <Typography variant="subtitle2">Status</Typography>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <Typography variant="subtitle2">Actions</Typography>
            </Grid>
          </Grid>
          {this.state.selectedPages.map((item, index) => (
            <Grid
              container
              key={index}
              sx={{
                p: 2,
                borderBottom: "1px solid #eee",
                "&:last-child": { borderBottom: 0 },
                alignItems: "center",
              }}
            >
              <Grid item lg={3} md={3} sm={3} xs={12}>
                <Typography variant="body1">{item.photosetName}</Typography>
                <Typography variant="caption" color="textSecondary">
                  {item.id}
                </Typography>
              </Grid>
              <Grid item lg={2} md={2} sm={2} xs={4}>
                <Typography variant="body2">
                  {Moment.unix(item.createdAt).format("YYYY/MM/DD")}
                </Typography>
              </Grid>
              <Grid item lg={3} md={3} sm={3} xs={8}>
                <Typography variant="body2">{item.userId}</Typography>
              </Grid>
              <Grid item lg={2} md={2} sm={2} xs={10}>
                <Chip
                  label={item.photosetStatus}
                  size="small"
                  color={item.photosetStatus === "SUCCESS" ? "success" : "warning"}
                />
              </Grid>
              <Grid item lg={2} md={2} sm={2} xs={2}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => this.showDetailsModal(item.id)}
                >
                  Details
                </Button>
              </Grid>
            </Grid>
          ))}
        </Paper>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <MuiPagination
            count={this.state.pages}
            page={this.state.activePage}
            onChange={(e, value) => this.pagination(value)}
            color="primary"
          />
        </Box>
      </Box>
    );
  }
}

const withHooks = (Component) => {
  return (props) => {
    const navigate = useNavigate();
    return <Component navigate={navigate} {...props} />;
  };
};

export default withHooks(AdminDashboard);
